import StyledText from './styles';

// const Text = ({ text }) => <StyledText>{text}</StyledText>

export default StyledText;
